import { EDIT_GROUP_MODULE_PERMISSIONS_REQUEST, EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS, EDIT_GROUP_MODULE_PERMISSIONS_FAILURE } from '../constants/edit_group_data.constants';

export const editGroupModulePermissionsRequest = (target, status) => ({
    type: EDIT_GROUP_MODULE_PERMISSIONS_REQUEST, target, status,
});

export const editGroupModulePermissionsSuccess = payload => ({
    type: EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS, payload,
});

export const editGroupModulePermissionsFailure = error => ({
    type: EDIT_GROUP_MODULE_PERMISSIONS_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/edit_group_module_permissions.actions.js